/*
 * @Author: your name
 * @Date: 2022-03-01 11:28:47
 * @LastEditTime: 2022-03-01 11:32:09
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \tongxing\src\store\getters.js
 */

export default {
    winHeight: state => state.userFactory.winHeight,
    winWidth: state => state.userFactory.winWidth,
    navbar: state => state.userFactory.navbar,
    tabbar: state => state.userFactory.tabbar,
    userInfo: state => state.userFactory.userInfo
}